<div class="flex-row main-block pt-5 pl-3 pb-2">
    <div class="mb-3 sidebar-left-block">
        <div class="flex mt-3 back-to-login-btn" (click)="cancel()">
            <img src="../Content/xpress-app/images/operator/signup/arrow-left.svg" />
            <span class="ml-2 text-small-normal btn-back">Back</span>
        </div>
        <div class="flex mt-4">
            <div>
                <div *ngIf="!profile.ImageUrl" class="profile-avatar-empty" [ngClass]="{'cursor-pointer': showEdit}">
                    <div  class="pt-3 ml-3 fs-16">{{profile.FirstName | slice:0:1 | uppercase}}{{profile.LastName | slice:0:1 | uppercase}}</div>
                </div>
                <img  [ngClass]="{'hidden': !avatarHover}" class="profile-avatar-hover" src="../Content/xpress-app/images/eye.svg" (click)="showPhotoImageModal()"/>
                <div class="avatar-block" *ngIf="profile.ImageUrl" (mouseenter)="avatarHover = true" (mouseleave)="avatarHover = false" >
                    <img  class="profile-avatar-empty" src="{{profile.ImageUrl}}" (click)="showPhotoImageModal()"/>
                </div>
            </div>

            <div class="ml-3">
                <div class="flex">
                    <div class="common-font-medium driver-name">{{profile.FirstName + ' ' + profile.LastName}}</div>
                </div>
                <div class="flex mt-3">
                    <div class="mr-2">
                        <span class="date-label">SIGNUP DATE </span>
                        <span class="date-value">{{moment(Utils.utcToLocalDate(profile.SignUpDate)).format('D MMM yyyy')}}</span>
                    </div>
                    <div>
                        <span class="date-label">LAST ACTIVE </span>
                        <span class="date-value">{{moment(Utils.utcToLocalDate(profile.LastActive)).fromNow()}}</span>
                    </div>
                </div>
            </div>
        </div>
        <hr *ngIf="isOperator()" class="mt-3 delimiter">

        <div *ngIf="isOperator()" class="flex">
            <div class="label-column ml-3">
                <div class="sidebar-text docs-text sidebar-left-label" [ngClass]="showEdit ? 'mt-2' : ''">Company Name:</div>
            </div>
            <div class="pl-6 ml-1 right-column w-100">
                <div  class="sidebar-text sidebar-left-value">
                    {{profile.CompanyName}}
                </div>
            </div>
        </div>

        <hr *ngIf="isOperator()" class="mt-3 delimiter">

        <div class="flex">
            <div class="label-column">
                <div class="ml-3 sidebar-text docs-text sidebar-left-label" [ngClass]="showEdit ? 'mt-5' : 'mt-3'">First Name:</div>
                <div class="ml-3 sidebar-text docs-text sidebar-left-label" [ngClass]="showEdit ? 'mt-5' : 'mt-3'">Last Name:</div>
                <div *ngIf="!showEdit && isOperator()" class="ml-3 sidebar-text docs-text sidebar-left-label" [ngClass]="showEdit ? 'mt-5' : 'mt-3'">Operator Code:</div>
                <div class="ml-3 sidebar-text docs-text sidebar-left-label" [ngClass]="showEdit ? 'mt-5' : 'mt-3'">Email:</div>
                <div class="ml-3 sidebar-text docs-text sidebar-left-label" [ngClass]="showEdit ? 'mt-5' : 'mt-3'">Address:</div>
                <div class="ml-3 sidebar-text docs-text sidebar-left-label" [ngClass]="showEdit ? 'mt-5' : 'mt-3'">Birth Date:</div>
                <div class="ml-3 sidebar-text docs-text sidebar-left-label" [ngClass]="showEdit ? 'mt-5' : 'mt-3'">Sex:</div>
            </div>

            <div class="pl-6 ml-1 right-column w-100">

                <div  class="mt-3 sidebar-text sidebar-left-value">{{profile.FirstName}}</div>
                <div  class="mt-3 sidebar-text sidebar-left-value">{{profile.LastName}}</div>
                <div *ngIf="!showEdit && isOperator()" class="mt-3 sidebar-text sidebar-left-value operator-code-tag">{{profile.OperatorCode ? profile.OperatorCode : 'N/A'}}</div>   
                <div  class="mt-3 sidebar-text sidebar-left-value">{{profile.Email}}</div>
                <div  class="mt-3 sidebar-text sidebar-left-value">{{profile.Address}}</div>
                <div  class="mt-3 sidebar-text sidebar-left-value">{{moment(profile.BirthDate).format('MMM D, yyyy')}}</div>
                <div  class="mt-3 sidebar-text sidebar-left-value">{{profile.Sex}}</div>
            </div>
        </div>
        <hr *ngIf="isOperator()" class="mt-3 delimiter">

        <div *ngIf="isOperator()" class="flex">
            <div class="label-column ml-3">
                <div class="sidebar-text docs-text sidebar-left-label" [ngClass]="showEdit ? 'mt-2' : ''">TIN:</div>
            </div>
            <div class="pl-6 ml-5 right-column w-100">
                <div  class="sidebar-text sidebar-left-value">{{profile.TaxNumber}}</div>
            </div>
        </div>

        <hr *ngIf="isOperator()" class="mt-3 delimiter">

        <div *ngIf="isOperator()" class="flex">
            <div class="label-column">
                <div class="ml-3 mt-3 sidebar-text docs-text sidebar-left-label" [ngClass]="showEdit ? 'mt-5' : 'mt-3'">Bank Name:</div>
                <div class="ml-3 mt-3 sidebar-text docs-text sidebar-left-label" [ngClass]="showEdit ? 'mt-5' : 'mt-3'">Account Name:</div>
                <div class="ml-3 mt-3 sidebar-text docs-text sidebar-left-label" [ngClass]="showEdit ? 'mt-5' : 'mt-3'">Account Number:</div>
            </div>
            <div class="pl-6 ml-1 right-column w-100">
                <div  class="mt-3 sidebar-text sidebar-left-value">{{ profile.BankName }}</div>
                <div  class="mt-3 sidebar-text sidebar-left-value">{{ profile.AccountName }}</div>
                <div  class="mt-3 sidebar-text sidebar-left-value">{{ profile.AccountNumber }}</div>
            </div>
        </div>

        <div class="flex title-float-right left-block-bottom-btns mt-3">
            <div  class="btn btn-default btn-update-push ml-3" (click)="editDetails()">Edit Details</div>
        </div>
    </div>

    <div class="ml-3 mb-3 sidebar-right-block">
        <p-tabMenu [model]="menuItems" [scrollable]="true" [activeItem]="activeItem" (activeItemChange)="onActiveItemChange($event)"></p-tabMenu>
        <ng-container *ngIf="activeItem === menuItems[0] && isOperator()">
            <document-image [profile]="profile" [initialProfile]="initialProfile" (updateUserProfile)="updateUser($event)" ></document-image>
        </ng-container>
        <ng-container *ngIf="activeItem === menuItems[isOperator() ? 1: 0]">
            <change-password [profile]="profile"></change-password>
        </ng-container>
    </div>
</div>

<spinner *ngIf="isSpinnerVisible" class="profile-spinner"></spinner>  

<p-galleria [value]="infoItems"
            [baseZIndex]="11000"
            [(visible)]="displayImg"
            [(activeIndex)]="activeImgIndex"
            [responsiveOptions]="imageOptions"
            [containerStyle]="{'max-width': '50%'}"
            [showThumbnails]="false" [fullScreen]="true" [showItemNavigators]="false">
    <ng-template pTemplate="item" let-item>
        <img [src]="item.value" class="galleria-image"/>
    </ng-template>
</p-galleria>

<confirm-modal [discardConfirmDialog]="discardConfirmDialog" (hideConfirmModal)="hideConfirmModal($event)"></confirm-modal>
<edit-profile-details [profile]="profile" [editDialog]="editDialog" *ngIf="editDialog" [temporaryProfile]="temporaryProfile"
    (hideProfileModal)="hideProfileModal($event)" (updatingUserProfile)="updateUserProfile(false, $event)"></edit-profile-details>